'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Parser2 = require('./Parser');

var _Parser3 = _interopRequireDefault(_Parser2);

var _getCurrentHref = require('./utils/getCurrentHref');

var _getCurrentHref2 = _interopRequireDefault(_getCurrentHref);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentsCount = (_temp = _class = function (_Parser) {
  (0, _inherits3.default)(CommentsCount, _Parser);

  function CommentsCount() {
    (0, _classCallCheck3.default)(this, CommentsCount);
    return (0, _possibleConstructorReturn3.default)(this, _Parser.apply(this, arguments));
  }

  CommentsCount.prototype.renderComponent = function renderComponent() {
    var _props = this.props,
        _props$href = _props.href,
        href = _props$href === undefined ? (0, _getCurrentHref2.default)() : _props$href,
        children = _props.children;


    return _react2.default.createElement(
      'span',
      {
        className: 'fb-comments-count',
        'data-href': href
      },
      children
    );
  };

  return CommentsCount;
}(_Parser3.default), _class.propTypes = (0, _extends3.default)({}, _Parser3.default.propTypes, {
  href: _propTypes2.default.string,
  children: _propTypes2.default.node
}), _temp);
exports.default = CommentsCount;


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/CommentsCount.js
// module id = 1601
// module chunks = 1